const ExpressFlyers = () => {
    return (
      <div>
      
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Express Flyer
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Express Flyer is the most popular service of TCS. The name is derived from and based on the iconic 
              sealed bag made of strong, recyclable, water-proof and tear-resistant, d2w-compliant Virgin material. 
              The bag, once sealed, cannot be opened with an intention to re-seal, thus making it impossible to hide 
              the signs of tempering with the enclosed contents. The Express Flyer can be used with a host of value-added 
              services e.g. the Overnight Express.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
          <img src="/DomesticScrollingBanner/scrolling-image7.jpg" alt="" className="rounded-md max-w-[100%]"/>
           
          </div>
        </div>
      
      </div>
    </div>

  )
};
export default ExpressFlyers;